import React, { useCallback, useState, useEffect, useRef } from "react";
import { BetslipContext } from "./BetslipConf";

export const BetslipSelectionsContext = React.createContext(null);


function BetslipSelectionsConf(props) { //Components who wish to be notified of changes to betslip selections should use this context provider
    const ctxs = useRef({}).current;
    ctxs.betslipContext = React.useContext(BetslipContext);

    const isDrawSelected = useCallback((pal, avv, cs, h, codDraw) => {
        return ctxs.betslipContext.isDrawSelected(pal, avv, cs, h, codDraw);
    },[]);

    const toggleSelectionBetslip = useCallback((pal, avv, eventAlias, descAvv, isLive, cs, hand, descBet, codDraw, descDraw, odd, legabile, descSport, descTournament, timestamp, sportIdSource, tournamentId, minPl, maxPl) => {
        return ctxs.betslipContext.toggleSelectionBetslip(pal, avv, eventAlias, descAvv, isLive, cs, hand, descBet, codDraw, descDraw, odd, legabile, descSport, descTournament, timestamp, sportIdSource, tournamentId, minPl, maxPl,null);
    },[]);

    const isEventSelected = useCallback((pal,avv) => {
        return ctxs.betslipContext.isEventSelected(pal, avv);
    },[]);

    const [betslipSelectionsContext, setBetslipSelectionsContext] = useState({
        update : function(updt) {
			
			//update effectly
			setBetslipSelectionsContext(prev => {
                return {...prev, ...updt};
            });
        },

        isDrawSelected: isDrawSelected,
        isEventSelected: isEventSelected,
        toggleSelectionBetslip: toggleSelectionBetslip
    });

    useEffect(() => {
        betslipSelectionsContext.update({isDrawSelected,isEventSelected,toggleSelectionBetslip})
    }, [ctxs.betslipContext.selectionMap]);

    return (
    	<BetslipSelectionsContext.Provider value={betslipSelectionsContext}>
    	    {props.children}
    	</BetslipSelectionsContext.Provider>
    );
}

export default BetslipSelectionsConf;